import React, { PropsWithChildren } from 'react';
import 'twin.macro';
import { Legend, LegendVariant } from './Legend';
import { TwStyle } from 'twin.macro';

export interface FieldsetProps {
  label?: string;
  className?: string;
  legendVariant?: LegendVariant;
  required?: boolean;
  legendStyle?: TwStyle;
}

export function Fieldset(props: PropsWithChildren<FieldsetProps>) {
  const { children, label, className, legendVariant, required, legendStyle } =
    props;

  return (
    <fieldset className={className}>
      {label && (
        <Legend variant={legendVariant} style={legendStyle} required={required}>
          {label}
        </Legend>
      )}
      {children}
    </fieldset>
  );
}
